
<div class="ActiveUserList DesktopOnly">
  <UsernameRow
    v-for="(u, clientID) in activeUsers"
    v-bind:key="clientID"
    v-bind:username="u.username || 'anonymous'"
    v-bind:color="u.color"
  ></UsernameRow>
</div>
